import { render, staticRenderFns } from "./FreeV2.vue?vue&type=template&id=1cf16044&scoped=true"
import script from "./FreeV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeV2.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf16044",
  null
  
)

export default component.exports